<template>
    <div class="information">
        <el-row class="search-row">
            <el-input v-model="searchString1" placeholder="全字段搜索" style="width:250px;"></el-input>
                <el-select v-model="resultStatus" placeholder="请选择" style="margin-left:15px;">
                    <el-option
                    v-for="item in Processing"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <div class="date-picker-container">
                    <div class="date-picker-item">
                        <span class="demonstration">时间范围：</span>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            placeholder="选择开始日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :clearable="true">
                        </el-date-picker>
                        <span class="date-separator">至</span>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            placeholder="选择结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            :clearable="true">
                        </el-date-picker>
                    </div>
                </div>
            <el-button type="primary" @click="search2" style="margin-left:15px;">搜索</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
        </el-row>
        <el-table :data="tableData" border style="width: 100%;margin-top:20px;">
            <el-table-column prop="unknownNumber" label="编号" align="center"></el-table-column>
            <el-table-column prop="internalConveyNumber" label="国内单号" align="center"></el-table-column>
            <el-table-column label="未知说明" align="center">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image 
                            style="width: 55px; height: 55px;float: left;"
                            :src="scope.row.unknownImages[0]" 
                            :preview-src-list="scope.row.unknownImages">
                        </el-image>
                    </div>
                    <span>
                        <div>{{ scope.row.unknownDescription }}</div>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="处理结果" align="center">
                <template slot-scope="scope">
                    <span style="color: red;" v-if="scope.row.resultStatus == 0">未处理</span>
                    <span v-if="scope.row.resultStatus == 1">申请转库存</span>
                    <span v-if="scope.row.resultStatus == 2">确认转库存</span>
                    <span v-if="scope.row.resultStatus == 3">申请退件</span>
                    <span v-if="scope.row.resultStatus == 4">确认退件</span>
                    <span v-if="scope.row.resultStatus == 5">申请关联采购需求</span>
                    <span v-if="scope.row.resultStatus == 6">确认关联采购需求</span>
                    <span v-if="scope.row.resultStatus == 7">申请重新入库</span>
                </template>
            </el-table-column>
            <el-table-column prop="handleDescription" label="处理方案" align="center"></el-table-column>
            <el-table-column prop="handleTime" label="采购处理时间" sortable align="center"></el-table-column>
            <el-table-column prop="createTime" label="报未知时间" sortable align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="operation(scope.row)">未知件详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[50, 100, 200, 400]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        </div>

        <el-dialog title="未知件详情" :visible.sync="details" width="26%" class="details">
                <el-form>
                    <el-form-item label="未知件编号：">
                        <span>{{detailsList.unknownNumber}}</span>
                    </el-form-item>
                    <el-form-item label="国内运单号：">
                        <span>{{detailsList.internalConveyNumber}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-row class="box">
                        <div v-for="(item,i) in this.detailsList.unknownImages" :key="i">
                            <div class="demo-image__preview">
                                <el-image 
                                    :z-index="2200"
                                    style="width:100px;height:100px;margin-left:10px;"
                                    :src="item" 
                                    :preview-src-list="[item]">
                                </el-image>
                            </div>
                        </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="未知说明：">
                        <span  style="color: red;">{{detailsList.unknownDescription}}</span>
                    </el-form-item>
                </el-form>
                <el-row type="flex" justify="space-between" align="middle">
                  <div style="width: 110px;">处理方案：</div>
                  <el-input style="margin-right: 10px;" v-model="handleDescription"></el-input>
                  <el-button type="primary" @click="saveHandleDescription">保存</el-button>
                </el-row>
                <span slot="footer" class="dialog-footer" v-if="this.detailsList.resultStatus == 0">
                    <!-- <el-button type="primary" @click="againPutWarehouse" v-if="this.str.departmentName == '采购部'">重新入库</el-button> -->
                    <el-button type="primary" @click="demand = true" v-if="this.str.departmentName == '采购部'">关联采购需求</el-button>
                    <!-- <el-button type="primary" @click="TurnInventory = true" v-if="this.str.departmentName == '采购部'">转库存</el-button> -->
                    <el-button type="primary" @click="TheProduct" v-if="this.str.departmentName == '采购部'">退件</el-button>
                </span>
        </el-dialog>

        <el-dialog title="退件处理" width="25%" :visible.sync="innerVisible" append-to-body>
            <el-button type="text" @click="fifthVisible = true">新增地址</el-button>
            <el-button type="primary" @click="openThirdDialog">选择地址</el-button>
            <div class="out-handle-box" style="margin-top:15px;">
                <el-row type="flex">
                    <h4>收件人：</h4>
                    <p>{{ this.innerData.recipientName }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收货地址：</h4>
                    <p>{{ this.innerData.receivingAddress }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>收件人电话：</h4>
                    <p>{{ this.innerData.recipientTelephone }}</p>
                </el-row>
                <el-row type="flex">
                    <h4>备注：</h4>
                    <p>{{ this.innerData.remarks }}</p>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="infoChange()">确 定</el-button>
            </div>
            <el-dialog width="40%" title="选择地址" :visible.sync="thirdVisible" append-to-body>
                <el-table :data="tableThird" border>
                    <!-- <el-table-column type="selection" width="50" align="center"></el-table-column> -->
                    <el-table-column property="remarks" label="备注" width="100" align="center"></el-table-column>
                    <el-table-column
                        property="recipientName"
                        label="收件人"
                        width="100"
                        align="center"
                    ></el-table-column>
                    <el-table-column property="receivingAddress" label="收件地址" align="center"></el-table-column>
                    <el-table-column
                        property="recipientTelephone"
                        label="电话"
                        width="200"
                        align="center"
                    ></el-table-column>
                    <el-table-column label="操作" width="140" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="addressConfirm(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="thirdVisible = false">取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog width="600px" title="新增地址" :visible.sync="fifthVisible" append-to-body>
              <el-form label-width="100px">
                <el-form-item label="收货地址">
                  <el-input v-model="fifthForm.receivingAddress"></el-input>
                </el-form-item>
                <el-form-item label="收件人">
                  <el-input v-model="fifthForm.recipientName"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话">
                  <el-input v-model="fifthForm.recipientTelephone"></el-input>
                </el-form-item>
                   <el-form-item label="备注">
                    <el-input v-model="fifthForm.remarks"></el-input>
                </el-form-item>

              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="fifthVisible = false">取 消</el-button>
                 <el-button type="primary" @click="increaseAddress">确 定</el-button>
              </div>
            </el-dialog>

        </el-dialog>

        <el-dialog title="采购需求" width="65%" :visible.sync="demand" append-to-body :close-on-click-modal="false">
            <el-row>
                <el-input v-model.trim="searchString" style="width:70%;" 
                @change="associated"
                placeholder="请输入订单号"></el-input>
                <el-button type="primary" style="margin-left:10px;" @click="associated">搜索</el-button>
            </el-row>
            <el-table :data="searchData" border style="width: 100%;margin-top:10px;">
                <el-table-column prop="orderId" label="订单号" align="center" width="150"></el-table-column>
                <el-table-column prop="" label="产品信息" align="center" width="250">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.orderItems" :key="item.id">
                            <div class="product">
                                <el-popover trigger="hover" placement="bottom-start">
                                    <img :src="item.imageUrl" alt  style="width:200px;height:200px;"/>
                                    <div class="scope_img" slot="reference">
                                        <img :src="item.imageUrl" alt style="width:50px;height:50px;margin-left:10px;"/>
                                    </div>
                                </el-popover>
                                <div style="margin-left:10px;">
                                    <p>price:{{item.itemAmount}} {{item.itemCurrencyCode}}</p>
                                    <p>SKU:{{item.sellerSKU}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="采购单据号" align="center">
                    <template slot-scope="scope">
                        <p v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">{{item.purchaseNumber}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="采购价" align="center" width="80">
                    <template slot-scope="scope">
                        <p v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">
                            <span v-if="item.purchasePrice!==''&&item.purchasePrice!==null">{{item.purchasePrice}}</span>
                            <span v-if="item.purchasePrice==''||item.purchasePrice==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="物流公司" align="center" width="100">
                    <template slot-scope="scope">
                        <p v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">
                            <span v-if="item.logisticsCompany!==''&&item.logisticsCompany!==null">{{item.logisticsCompany}}</span>
                            <span v-if="item.logisticsCompany==''||item.logisticsCompany==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="国内运单号" align="center">
                    <template slot-scope="scope">
                        <p v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">
                            <span v-if="item.internalConveyNumber!==''&&item.internalConveyNumber!==null">{{item.internalConveyNumber}}</span>
                            <span v-if="item.internalConveyNumber==''||item.internalConveyNumber==null">--</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="是否无效" align="center" width="80">
                    <template slot-scope="scope">
                        <p v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">
                            <span v-if="item.invalidStatus == 1">正常</span>
                            <span v-if="item.invalidStatus == 0" style="color:red;">无效</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="230">
                    <template slot-scope="scope">
                        <div v-for="(item,i) in scope.row.purchases" :key="i" style="margin-top:15px;">
                            <el-tooltip class="item" effect="dark" :content="item.purchaseModel" placement="top">
                                <el-button type="primary" @click="toView(item)">查看</el-button>
                            </el-tooltip>
                            <el-button type="danger" @click="taginvalid(item)" :disabled="item.invalidStatus == 0">标记为无效单据</el-button>
                        </div>
                        <!-- <el-button type="primary" @click="determine(scope.row)">确定</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <p style="color:red;margin-top:15px;">注：请务必将无用的采购单据标记为无效状态，库房将对该无效状态的单据不进行信息核对!</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="Add">新增采购单据</el-button>
            </span>
        </el-dialog>
        
        <el-dialog title="未知转自建库存" width="30%" :visible.sync="TurnInventory" append-to-body>
            <div>
                <el-upload
                    ref="upload"
                    :action="action"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :headers="customHeaders"
                >
                <i class="el-icon-plus" style="color: #0724ef;"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible1" append-to-body>
                    <img width="100%" :src="dialogImageUrl1" alt />
                </el-dialog>
            </div>
            <el-form :model="form" :rules="rules" ref="form" label-width="130px" class="inventoryForm">
                <el-form-item label="商品全称：" prop="productFullName">
                    <el-input v-model="form.productFullName" style="width:45%;" placeholder="全称"></el-input>
                </el-form-item>
                <el-form-item label="商品简称：" prop="productSimpleName">
                    <el-input v-model="form.productSimpleName" style="width:45%;" placeholder="简称"></el-input>
                </el-form-item>
                <el-form-item label="库存单价：" prop="purchasePrice">
                    <el-input v-model="form.purchasePrice" style="width:45%;"></el-input>
                </el-form-item>
                <el-form-item label="商品描述：" prop="productDescription">
                    <el-input v-model="form.productDescription" style="width:90%;" placeholder="规格型号说明"></el-input>
                </el-form-item>
                <el-form-item label="自建库存数量：" prop="predictCount">
                    <el-input-number v-model="form.predictCount" :min="1" size="mini"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')">取 消</el-button>
                <el-button :disabled="Forbid_click" type="primary" @click="inventory('form')">确定</el-button>
            </div>
        </el-dialog>

        <!-- 添加采购单 -->
        <el-dialog width="54%" top="30vh" title="添加采购单" :visible.sync="AddinnerVisible" append-to-body>
            <el-row class="border-bottom padding">
                <el-col :span="25">
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="purchaseModel1">
                                <template slot="prepend">
                                    <el-tooltip content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对" placement="top">
                                        <el-button>海逊仓库核对详情:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <el-input v-model="purchasePrice1">
                                <template slot="prepend">
                                    采购价:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="rebatePrice1">
                                <template slot="prepend">
                                    <el-tooltip content="购买后,卖家返回的佣金" placement="top">
                                        <el-button>返佣:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="otherPrice1">
                                <template slot="prepend">
                                    退款费用:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <span class="leix">类型:</span>
                            <el-select
                                v-model="purchaseTypeCode1"
                                placeholder="请选择"
                                style="width: 77%;"
                                class="logistics"
                            >
                                <el-option
                                    v-for="item in this.selectType"
                                    :key="item.value"
                                    :label="item.itemTypeName"
                                    :value="item.itemTypeName"
                                ></el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <span class="leix">物流公司:</span>
                            <el-select v-model="logisticsCompany1" @change="SelectLogistics1" value-key="id" filterable clearable placeholder="请选择" style="width: 62%;" class="logistics">
                                <el-option
                                v-for="item in Logistics"
                                :key="item.id"
                                :label="item.logisticsCompanyName"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="padding" :span="15">
                            <el-input v-model.trim="internalConveyNumber1" disabled>
                                <template slot="prepend">
                                    运单号码:
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="remark1">
                                <template slot="prepend">
                                    <el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
                                        <el-button>采购备注:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <p style="margin-top:15px;color:red;">
                注：请补充填写该单据空白处所需要的信息！
            </p>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="determine()" :loading="isLoading">保存</el-button>
                <el-button @click="AddPurchasebCancel">取消</el-button>
            </div>
        </el-dialog>

        <!-- 查看采购单 -->
        <el-dialog width="54%" top="30vh" title="查看采购单" :visible.sync="AddinnerVisible1" append-to-body>
            <el-row class="border-bottom padding">
                <el-col :span="25">
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="purchaseModel2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对" placement="top">
                                        <el-button>海逊仓库核对详情:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <el-input v-model="purchasePrice2" disabled>
                                <template slot="prepend">
                                    采购价:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="rebatePrice2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="购买后,卖家返回的佣金" placement="top">
                                        <el-button>返佣:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <el-input v-model="otherPrice2" disabled>
                                <template slot="prepend">
                                    退款费用:
                                </template>
                            </el-input>
                        </el-col>
                        <el-col class="padding" :span="5">
                            <span class="leix">类型:</span>
                            <el-input v-model="purchaseTypeCode2" disabled style="width: 77%;" class="logistics"></el-input>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col class="padding" :span="5">
                            <span class="leix">物流公司:</span>
                            <el-input v-model="logisticsCompany2" disabled style="width: 62%;" class="logistics"></el-input>
                        </el-col>
                        <el-col class="padding" :span="15">
                            <el-input v-model.trim="internalConveyNumber2" disabled>
                                <template slot="prepend">
                                    运单号码:
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col class="padding" :span="20">
                            <el-input v-model="remark2" disabled>
                                <template slot="prepend">
                                    <el-tooltip content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见" placement="top">
                                        <el-button>采购备注:</el-button>
                                    </el-tooltip>
                                </template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

        </el-dialog>


    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    name: "Unknown",
    data() {
        return {
            str:"",
            tableData: [],
            details:false,
            detailsList:"",
            AddinnerVisible:false,
            AddinnerVisible1:false,
            isLoading:false,

            Forbid_click:false,
            thirdVisible:false,
            innerVisible:false,
            demand:false,
            TurnInventory:false,
            tableThird: [],
            innerData:{},
            searchString:"",
            searchString1:"",
            searchData:[],

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            dialogVisible1: false,
            dialogImageUrl1: "",
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            imageData: [],
            arrimage:[],
            imageList:[],
            resultStatus:"",
            startTime: "", // 开始日期
            endTime: "", // 结束日期
            Processing:[
                {label:"未处理",value:0},
                {label:"申请转库存",value:1},
                {label:"申请退件",value:3},
                {label:"申请关联采购需求",value:5},
            ],

            form:{
                productFullName:"",
                productSimpleName:"",
                purchasePrice:"",
                productDescription:"",
                predictCount:""
            },
            fifthVisible: false,
            fifthForm: {
              receivingAddress: '',
              recipientName: '',
              recipientTelephone: '',
                remarks: ''
            },

            purchasePrice1: "", //采购价
            purchaseModel1: "", //采购详情
            rebatePrice1: "", //返佣
            otherPrice1: "", //退款费用
            purchaseTypeCode1: "", //采购类型
            remark1: "", //采购备注
            internalConveyNumber1: "", //运单号码
            logisticsCompany1: "", //物流公司
            companyCode1: "", //物流公司编码

            purchasePrice2: "", //采购价
            purchaseModel2: "", //采购详情
            rebatePrice2: "", //返佣
            otherPrice2: "", //退款费用
            purchaseTypeCode2: "", //采购类型
            remark2: "", //采购备注
            internalConveyNumber2: "", //运单号码
            logisticsCompany2: "", //物流公司
            companyCode2: "", //物流公司编码

            selectType: "",
            Logistics:[],
            purchaseDemandId:"",

            rules: {
                productFullName: [
                    { required: true, message: '请填写商品全称', trigger: 'blur' },
                ],
                productSimpleName: [
                    { required: true, message: '请填写商品简称', trigger: 'blur' },
                ],
                purchasePrice: [
                    { required: true, message: '请填写库存单价', trigger: 'blur' },
                ],
                productDescription: [
                    { required: true, message: '请填写商品描述', trigger: 'blur' },
                ],
                predictCount: [
                    { required: true, message: '请输入自建库存数量', trigger: 'blur' },
                ],
            },
            handleDescription: ''
        };
    },
    mounted() {
        // 先初始化默认日期范围为近3个月
        this.initDefaultDateRange();
        // 然后执行搜索,确保日期范围生效
        this.search();
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
    },
    methods: {
        // 初始化默认日期范围（近3个月）
        initDefaultDateRange() {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 3);

            this.startTime = this.formatDate(startDate);
            this.endTime = this.formatDate(endDate);
        },

        // 格式化日期为 YYYY-MM-DD
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        typeCode() {
            var itemCode = {
                itemCode: "HYXUN0000001",
            };
            ajaxPost(Baseurl + "purchaseController/selectItemList", itemCode).then(res => {
                this.selectType = res.data.data;
            });
        },
        LogisticsAjax(){
            ajaxPost(Baseurl + "logisticsController/getLogisticsCompanyList").then(res => {
                    if (res.data.code == 200) {
                        this.Logistics = res.data.data
                    }
            });
        },
        operation(val){
            this.details = true
            this.detailsList = val
            console.log(this.detailsList)
            this.handleDescription = val.handleDescription || ''
        },
        search2(){
            this.currentPage = 1
            this.search()
        },
        search() {
            // 处理日期范围参数
            let startTimeString = "";
            let endTimeString = "";
            if (this.startTime) {
                startTimeString = this.startTime + " 00:00:00";
            }
            if (this.endTime) {
                endTimeString = this.endTime + " 23:59:59";
            }

            var obj = {
                companyId:this.str.company_id,
                startTimeString: startTimeString,
                endTimeString: endTimeString,
                searchString: this.searchString1,
                resultStatus:this.resultStatus,
                page:this.currentPage,
                size:this.size,
                type:2
            };
            ajaxPost(Baseurl + "unknownManageController/selectUnknownManageList", obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        reset(){
            this.searchString1 = ""
            this.resultStatus = ""
            this.currentPage = 1
            // 重置日期范围为近3个月
            this.initDefaultDateRange();
            this.search()
        },
        associated(){
            if(this.searchString){
                var obj = {
                    orderId: this.searchString,
                    companyId: this.str.company_id,
                }
                ajaxPost(Baseurl + "unknownManageController/selectPurchaseDemandByOrderId", obj).then(res => {
                    if (res.data.code == 200) {
                        if (res.data.data == null) {
                            this.searchData = []
                        } else {
                            this.purchaseDemandId = res.data.data.id
                            this.searchData = [res.data.data]
                        }
                    }
                });
            }
        },
        determine(val){
            this.$confirm('点击保存，即将完成未知库存与订单的关联，库房将对该货物进行二次处理', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
                if(this.internalConveyNumber1 == ""&&this.logisticsCompany1!==""){
                    this.$message.error("物流公司和运单号码必须同时填写")
                }else if(this.internalConveyNumber1 !== ""&&this.logisticsCompany1 ==""){
                    this.$message.error("物流公司和运单号码必须同时填写")
                }else{
                    var obj = {
                        roleId:this.str.rid,
                        purchaseDemandId:this.purchaseDemandId,
                        id:this.detailsList.id,
                        resultStatus:5,
                        receiptNumber:this.detailsList.internalConveyNumber,
                        purchase:{
                            internalConveyNumber: this.internalConveyNumber1,
                            purchasePrice: this.purchasePrice1,
                            rebatePrice: this.rebatePrice1,
                            purchaseModel: this.purchaseModel1,
                            logisticsCompany: this.logisticsCompany1,
                            purchaseTypeCode: this.purchaseTypeCode1,
                            remark: this.remark1,
                            otherPrice: this.otherPrice1,
                            companyCode:this.companyCode1,
                            insertFrom:2
                        }
                    };
                    ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                        if(res.data.code == 200){
                            this.$message({
                                message: '关联采购需求成功',
                                type: 'success'
                            });
                            this.associated()
                            this.AddinnerVisible = false
                        }else{
                            this.$message.error(res.data.data);
                        }
                    });
                }
            })
        },
        inventory(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.arrimage = [];
                    for (var i = 0; i < this.imageData.length; i++) {
                        this.arrimage.push(this.imageData[i].data);
                    }
                    if(this.arrimage.length == 0){
                        this.$message.error('请上传未知库存的运单截图');
                    }else{
                        var obj = {
                            inventory:{
                                productFullName:this.form.productFullName,
                                productSimpleName:this.form.productSimpleName,
                                purchasePrice:this.form.purchasePrice,
                                productDescription:this.form.productDescription,
                                predictCount:this.form.predictCount,
                                imagesList:this.arrimage
                            },
                            id:this.detailsList.id,
                            resultStatus:1,
                            receiptNumber:this.detailsList.internalConveyNumber,
                            roleId: this.str.rid
                        }
                        this.Forbid_click = true;
                        // return;
                        ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                            if(res.data.code == 200){
                                this.$message({
                                    message: '未知转自建库存成功',
                                    type: 'success'
                                });
                                this.search()
                                this.$refs.upload.clearFiles();
                                this.$refs[formName].resetFields();
                                this.imageData = [];
                                this.TurnInventory = false;
                                this.details = false;
                                 this.Forbid_click = false;
                            }else{
                                 this.Forbid_click = false;
                                this.$message.error(res.data.data);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        cancel(formName){
            this.$refs[formName].resetFields();
            this.TurnInventory = false
        },
        //退件
        TheProduct(){
            const API = Baseurl + "logisticsController/selectDefaultAddressByCompanyId";
            const paramsData = {
                companyId: this.str.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    if(data === null){
                        this.$message.error('请先添加退件地址!');
                    }else{
                        this.innerData = data;
                        this.innerVisible = true;
                    }
                }
            });
        },
        //选择地址
        openThirdDialog() {
            const API = Baseurl + "logisticsController/selectReceivingAddressListByCompanyId";
            const paramsData = {
                companyId: this.str.company_id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.tableThird = data;
                    this.thirdVisible = true;
                }
            });
        },
        infoChange() {
            var obj = {
                id:this.detailsList.id,
                resultStatus:3,
                receiptNumber:this.detailsList.internalConveyNumber,
                roleId: this.str.rid,
                receivingAddressId: this.innerData.id
            };
            ajaxPost(Baseurl + "unknownManageController/updateUnknownManage", obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: '退件成功',
                        type: 'success'
                    });
                    this.search()
                    this.innerVisible = false
                    this.details = false
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        addressConfirm(row) {
            this.innerData = row;
            this.thirdVisible = false;
        },

        handleSizeChange(val) {
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
        },

        handleAvatarSuccess(file, fileList) {
            this.imageData.push(file);
        },
        handleRemove(file, fileList) {
            this.imageData = [];
            for (var i = 0; i < fileList.length; i++) {
                this.imageData.push(fileList[i].response);
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl1 = file.url;
            this.dialogVisible1 = true;
        },
        increaseAddress() {
            const API = Baseurl + 'receivingAddressController/insertReceivingAddress'
            const paramsData = {
                ...this.fifthForm,
                companyId: this.str.company_id
            }
             if(paramsData.receivingAddress == ""){
                    this.$message.warning("请填写收件人地址");
                    return;
              }else if(paramsData.recipientName == ""){
                   this.$message.warning("请填写收件人姓名");
                    return;
              }else if(paramsData.recipientTelephone == ""){
                   this.$message.warning("请填写收件人电话");
                    return;
              }
            // console.log(JSON.parse(JSON.stringify(paramsData)));
            // return;
            ajaxPost(API, paramsData).then(res => {
                const { code } = res.data
                if (code === 200) {
                  this.fifthVisible = false
                  this.$message.success('操作成功')
                }
            })
        },
        saveHandleDescription() {
          const API = Baseurl + 'unknownManageController/updateHandleDescription'
          const paramsData = {
            id: this.detailsList.id,
            handleDescription: this.handleDescription
          }
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功')
              this.search()
            } else {
              this.$message.error(data || '操作失败')
            }
          })
        },
        againPutWarehouse() {
          const API = Baseurl + 'unknownManageController/updateUnknownManage'
          const paramsData = {
            id: this.detailsList.id,
            resultStatus: 7,
            roleId: this.str.rid
          }
          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功')
              this.details = false
              this.search()
            } else {
              this.$message.error(data || '操作失败')
            }
          })
        },
        SelectLogistics1(val){
            // console.log(val)
            this.logisticsCompany1 = val.logisticsCompanyName
            this.companyCode1 = val.logisticsCompanyCode
        },
        Add(){
            this.AddinnerVisible = true;
            this.internalConveyNumber1 = this.detailsList.internalConveyNumber
            this.LogisticsAjax()
            this.typeCode()
        },
        AddPurchasebCancel(){
                this.purchasePrice1 = ""
                this.rebatePrice1 = ""
                this.purchaseModel1 = ""
                this.logisticsCompany1 =""
                this.purchaseTypeCode1 =""
                this.remark1 = ""
                this.otherPrice1 = ""
                this.internalConveyNumber1 = ""
                this.AddinnerVisible = false
        },
        taginvalid(val){
            this.$confirm('点击标记为无效状态时，库房将对此条国内运单不再进行核对，是否确认标记', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
            }).then(() => {
                var obj = {
                    id:val.id,
                    roleId:this.str.rid
                };
                ajaxPost(Baseurl + "purchaseController/updateInvalidStatusById", obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '标记为无效单据成功',
                            type: 'success'
                        });
                        this.associated()
                    }else{
                        this.$message.error(res.data.data);
                    }
                });
            })
            
        },
        toView(val){
            this.AddinnerVisible1 = true
            this.internalConveyNumber2 = val.internalConveyNumber
            this.purchasePrice2 = val.purchasePrice,
            this.rebatePrice2 = val.rebatePrice,
            this.purchaseModel2 = val.purchaseModel,
            this.logisticsCompany2 = val.logisticsCompany,
            this.purchaseTypeCode2 = val.purchaseTypeCode,
            this.remark2 = val.remark,
            this.otherPrice2 = val.otherPrice,
            this.companyCode2 = val.companyCode,
            console.log(val)
        }
    },
};
</script>

<style lang="scss" scoped>
/* 搜索行样式 */
.search-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

/* 日期选择器容器 */
.date-picker-container {
    display: flex;
    align-items: center;
    margin-left: 15px;
    gap: 15px;
}

/* 日期选择器单项 */
.date-picker-item {
    display: flex;
    align-items: center;
}

/* 日期标签文字样式 */
.demonstration {
    margin-right: 10px;
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
}

/* 日期分隔符样式 */
.date-separator {
    margin: 0 10px;
    color: #606266;
    font-size: 14px;
}

/deep/ {
    .details .el-form-item{
        margin-bottom: 0px!important;
    }

    /* 日期选择器宽度 */
    .date-picker-item .el-date-editor {
        width: 200px;
    }
}

.box{
    display: flex;
    justify-content: left;
}
.information {
    width: 98%;
    overflow: hidden;
    margin-bottom: 50px;
}
.prduct_img {
    width: 300px;
    height: 300px;
}
.padding {
    padding: 10px 0;
}
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    z-index: 99;
}
.product{
    display: flex;
    justify-content: left;
}
.product p{
    text-align: left;
}
.inventoryForm{
    margin-top:15px;
}
.leix {
    background-color: #f5f7fa;
    line-height: 30px;
    padding: 5px;
    border-left: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
    border-top: 1px solid #e4e7ed;
    color: #909399;
    border-radius: 4px 0px 0px 4px;
}
</style>
